import useBlogPost from "@/hooks/useBlogPost";
import { BlogPostingSchema } from "@/ui/BlogPostingSchema";
import { SeoHead } from "@/ui/SeoHead";
import getPaths from "@sourceflow-uk/functions/getPaths";
import { ContentBlocks } from "src/ui/ContentBlocks";

import trimText from "@/functions/trimText";
import * as additionalComponents from "./__components";

export default function BlogPostPage({ prefix, metadata, url_slug, data }) {
  return (
    <>
      <SeoHead {...metadata} titleTemplate="" />
      <BlogPostingSchema url_slug={url_slug} />
      <ContentBlocks data={data} prefix={prefix} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const { featured, title, image, blog_header_image, topics, content, author, published } = useBlogPost(url_slug);

  return {
    props: {
      prefix: `blog_${url_slug}`,
      metadata: {
        title,
        description: trimText(content, 158),
        canonical: `/blog/${url_slug}/`,
      },
      url_slug,
      data: [
        {
          component: "BlogPostHero",
          props: {
            featured,
            title,
            image,
            blog_header_image: blog_header_image ?? null,
            topics: topics ?? [],
            published,
            author: author
              ? {
                  name: author.name,
                  href: author.url_slug ? `/about-us/meet-team/${author.url_slug}` : null,
                }
              : null,
          },
        },
        {
          component: "BlogPostContent",
          props: {
            className: "pb-5 pb-lg-6",
            content,
            url_slug,
            title,
          },
        },
        {
          component: "ContentSideImages",
          props: {
            className: "py-5 py-md-7",
            title: "Looking for a New Role – or Searching for Top Talent? Let’s Talk",
            image_1: "/assets/blog_relocating_1.webp",
            image_2: "/assets/blog_relocating_2.webp",
            description:
              "<p>Whether you're exploring your next career move or looking to hire skilled professionals, HRS is here to help.</p><p>We connect ambitious individuals with exciting opportunities across science, technology, and innovation-led sectors. From early careers to executive search, our expert recruiters work closely with both candidates and employers to ensure the perfect match.</p><p>If you're hiring, we’ll help you find the right people. If you’re job hunting, we’ll help you take the next step. Browse our latest jobs or get in touch to find out how we can support you.</p>",
            buttons: [
              {
                label: "View all jobs",
                url: "/jobs/",
                variant: "blue",
              },
              {
                label: "Get in Touch",
                url: "/enquiry/",
                variant: "cyan",
              },
            ],
          },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: await getPaths("blog_posts"),
    fallback: false,
  };
}
